// https://github.com/nickbruun/svg-loaders
type PropsType = React.SVGAttributes<SVGElement> & {
  readonly size?: string | number
}
export default function Spinner(props: PropsType) {
  const { size = '1.5em' } = props
  return (
    <svg
      aria-hidden
      height={size}
      width={size}
      viewBox="0 0 2400 2400"
      {...props}
    >
      <g
        fill="none"
        strokeWidth="200"
        strokeLinecap="round"
        stroke="currentColor"
      >
        <path d="M1200 600V100" />
        <path opacity=".5" d="M1200 2300v-500" />
        <path opacity=".917" d="M900 680.4l-250-433" />
        <path opacity=".417" d="M1750 2152.6l-250-433" />
        <path opacity=".833" d="M680.4 900l-433-250" />
        <path opacity=".333" d="M2152.6 1750l-433-250" />
        <path opacity=".75" d="M600 1200H100" />
        <path opacity=".25" d="M2300 1200h-500" />
        <path opacity=".667" d="M680.4 1500l-433 250" />
        <path opacity=".167" d="M2152.6 650l-433 250" />
        <path opacity=".583" d="M900 1719.6l-250 433" />
        <path opacity=".083" d="M1750 247.4l-250 433" />
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          begin="0s"
          calcMode="discrete"
          dur="0.83333s"
          keyTimes="0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667"
          repeatCount="indefinite"
          type="rotate"
          values="0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199"
        />
      </g>
    </svg>
  )
}
